import moment from 'moment';
import { isUndecidedDate } from '../components/Calendar';

export class DateUtils {
    /**
     *
     * @param value
     * @returns data no formato -  18 de jun de 2024
     */
    static formatToDateString(value: Date) {
        return moment(value).format('DD MMM YYYY');
    }

    static formatPossibleDate(value: Date) {
        if (isUndecidedDate(value)) return 'Data ainda não definida';
        return moment(value).format('DD/MM/YYYY');
    }

    /**
     *
     * @param value
     * @returns horas - 22:44
     */
    static formatReturnHourDate(value: Date) {
        return moment(value).format('HH:mm');
    }

    /**
     *
     * @param value
     * @returns  dd/mm/yyyy
     */
    static formatSingleDate(value: Date) {
        return moment(value).format('L');
    }

    /**
     *
     * @param value
     * @returns  YYYY-MM-DD
     */
    static formatToInitalYear(value: Date) {
        return moment(value).format('YYYY-MM-DD');
    }

    /**
     *
     * @param value
     * @returns  DD-MM
     */
    static formatToDayMonth(value: Date) {
        return moment(value).format('DD/MM');
    }

    /**
     *
     * @param value
     * @returns  DD-MM-YYYY
     */
    static formatToDayMonthYear(value: Date) {
        return moment(value).format('DD/MM/YYYY');
    }

    /**
     *
     * @param value - Data de parameter
     * @returns  15 de julho de 2024
     */
    static formatToLargeStringDate(value: Date) {
        return moment(value).locale('pt').format('LL');
    }

    /**
     * Calcula a diferença em dias entre duas datas.
     *
     * @param {Date} startDate - A data de início.
     * @param {Date} endDate - A data de término.
     * @returns {number} Número de dias de diferença.
     */
    static calculateDaysDifference(startDate: Date, endDate: Date): number {
        const start = moment(startDate).startOf('day');
        const end = moment(endDate).startOf('day');
        return start.diff(end, 'days');
    }

    /**
     * Calcula a diferença em anos entre duas datas (idade).
     *
     * @param {Date} startDate - A data de início.
     * @param {Date} endDate - A data de término.
     * @returns {number} Número de dias de diferença.
     */
    static calculateYearsDifference(startDate: Date, endDate: Date): number {
        return moment(startDate).diff(endDate, 'years');
    }

    /**
     * Retorna o primeiro e o último dia do mês para a data fornecida.
     *
     * @param {Date} data - A data para a qual calcular o intervalo do mês.
     * @returns {[Date, Date]} O primeiro dia e o última dia do mês
     */
    static getDateMonthRange(data: Date) {
        const start = new Date(data.getFullYear(), data.getMonth(), 1);
        const end = new Date(data.getFullYear(), data.getMonth() + 1, 0);

        return [start, end];
    }

    /**
     * Compara se duas datas representam o mesmo dia.
     *
     * @param {Date | string} date1 - A primeira data a ser comparada.
     * @param {Date | string} date2 - A segunda data a ser comparada.
     * @returns {boolean} `true` se as datas forem no mesmo dia, caso contrário, `false`.
     */
    static areDatesEqual(date1: Date, date2: Date) {
        return moment(date1).isSame(date2, 'day');
    }

    /**
     * Retorna a data de ontem no fim do dia
     *
     * @returns {Date}
     */
    static yesterdayEndHour() {
        const yesterdayEndOfDay = moment().subtract(1, 'days').endOf('day');
        return yesterdayEndOfDay.toDate();
    }

    /**
     * Retorna um objeto com a hora, minuto e segundo atual
     * De acordo com o dispositivo do usuário
     *
     * @returns { hour: string, minute: string, second: string}
     */
    static currentHourMinutSecond() {
        const currentDate = moment();
        return {
            hour: currentDate.format('HH'),
            minute: currentDate.format('mm'),
            second: currentDate.format('ss'),
        };
    }
}
